<template>
  <div class="index-page container">
    <n-card :loading="$var('load')" style="max-width: 800px;">
      <n-form @submit="submit">
        <n-items>
          <n-input title="Заголовок" v-bind="$form.input('title')" />
          <n-button color="primary" wide type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
  }),
  mounted() {
    this.$form.init({
      title: '',
    })
  },
  methods: {
    submit() {
      this.$var('load', true)
      
      $api.app.categories.create(this.$form.get()).then((result) => {
        this.$router.push({ name: 'categories.edit', params: { id: result.data.content.id, }, })
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
  }
</style>
